import { productCarouselProductFullStyles } from "@insite/content-library/Components/ProductCarouselProductFull";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css, ThemeProps, withTheme } from "styled-components";

productCarouselProductFullStyles.imageGridItem = {
    width: 12,
    css: css`
        width: 100%;
        height: 270px;
        align-items: center;
        justify-content: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        height: 270px !important;
                    `,
                    null,
                    css`
                        height: 210px;
                    `,
                    null,
                ],
                "max",
            )};
    `,
};
productCarouselProductFullStyles.productImageStyles!.linkWrappingImage = {
    css: css`
        justify-content: center;
        max-height: 100%;
        img {
            max-height: 260px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            max-height: 260px !important;
                        `,
                        null,
                        css`
                            max-height: 200px;
                        `,
                        null,
                    ],
                    "max",
                )};
        }
    `,
};
productCarouselProductFullStyles.descriptionGridItem = {
    width: 12,
    css: css`
        padding: 5px 5px;
    `,
};

productCarouselProductFullStyles.priceGridItem = {
    width: 12,
    css: css`
        padding: 0px;
        > section {
            padding: 12px 15px 8px 5px;
        }
    `,
};
productCarouselProductFullStyles.partNumberGridItem = {
    width: 12,
    css: css`
        padding: 0px;
        > div {
            > div {
                padding: 5px 15px 5px 5px;
            }
        }
    `,
};
